import { v7 as uuidv7 } from 'uuid';

import type { TaskTextGenerateOptions, TaskUtils } from './types';

const NUMBERS = '0123456789';
const CHARACTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
const SPECIAL = '!@#$%^&*=+-_<>';
const DEFAULT_LENGTH = 16;

export function randomUuid(): string {
  return uuidv7();
}

export function generateText(options: TaskTextGenerateOptions = {}): string {
  const length = options.length ?? DEFAULT_LENGTH;
  let charset = CHARACTERS;

  if (options.includeNumbers) {
    charset += NUMBERS;
  }

  if (options.includeSpecial) {
    charset += SPECIAL;
  }

  let result = '';
  const charsetLength = charset.length;

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charsetLength);
    result += charset[randomIndex];
  }

  return result;
}

export const textUtils: TaskUtils['text'] = {
  randomUuid,
  generate: (options) => generateText(options ?? {})
};
